import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

export const LabeledValue = ({ label, value }: { label: string; value: ReactNode }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="subtitle2" fontWeight={600} mt={0.5}>
      {value}
    </Typography>
  </Box>
);
